<template>
  <div class="accordion-item--content">
    <slot name="elMarkup">
      <div
        :id="groupId + '-' + item.id"
        class="accordion-item--content__wrapper"
        :class="{ 'is-active': active }"
      >
        <!-- Accordion item: Header -->
        <slot name="header">
          <!-- <div class="accordion-item__header">
            <button @click="toggle" class="accordion-item__trigger" :disabled="readOnly">
              <h2 class="accordion-item__title">{{ title }}</h2>
              <span class="accordion-item__trigger--icon" v-if="!readOnly"></span>
            </button>
          </div> -->
        </slot>

        <transition
          name="accordion-item"
          @enter="startTransition"
          @after-enter="endTransition"
          @before-leave="startTransition"
          @after-leave="endTransition"
        >
          <div v-if="isActive" class="accordion-item-details">
            <div class="accordion-item-details-inner">
              <slot></slot>
            </div>
          </div>
        </transition>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      default: {}
    },
    title: {
      type: String,
      default: 'Accordion Item Title'
    },
    active: Boolean,
    multiple: Boolean,
    readOnly: Boolean
  },
  data() {
    return {
      groupId: null
    };
  },
  computed: {
    isActive: function() {
      return this.active;
    }
  },
  methods: {
    toggle(event) {
      if (this.multiple) this.active = !this.active;
      else {
        this.$parent.$children.forEach(item => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) {
            item.item.active = !item.item.active;
          } else item.item.active = false;
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    endTransition(el) {
      el.style.height = '';
    }
  },
  mounted() {
    this.groupId = this.$el.id;
    //console.log(this.$el);
  }
};
</script>

<style lang="scss" scoped>
$size: 20px;

.accordion-item__header {
  // position: relative;
  display: flex;
  align-content: center;
}

.accordion-item__trigger,
.accordion-item-details-inner {
  //padding: 0.75rem 1.25rem;
  padding: 0;
  margin: 12px 0 0 0;
}

.accordion-item__trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:disabled {
    cursor: pointer;
    pointer-events: none;
  }
}

.accordion-item__trigger--icon {
  // margin: 12px 0 0;

  &:after {
    background: url(../../../assets/img/ico-expand-list.svg) center center no-repeat;
    // transform: rotate(0deg);
    content: '';
    height: $size;
    width: $size;
    float: right;
  }
  // transform: translateY(-$size / 4) rotate(45deg);
  transform: rotate(0deg);
  transition: transform 0.2s ease;

  .is-active & {
    // transform: translateY($size / 4) rotate(225deg);

    &:after {
      transform: rotate(180deg);
    }
  }
}

.accordion-item-details {
  background-color: #ffffff;
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  max-height: 1000px;
  transition: height 0.1s ease-out;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
